import {
  EraseType,
  getCustomJudgeAreaGroup,
} from '@ps/workbench/undo-redo/module/erase'
import gameIframe from '@ps/bridge/iframe/iframe'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { nodeTypes } from '@ps/bridge/qc/scripts/editor'
import store from '@ps/store'
import { cloneNode } from '@ps/workbench/layer/node'
import { scripts } from '@ps/bridge/qc/scripts'
import { resetNodeDefaultLayout } from '@ps/bridge/qc/node/utils'
import { Event, EventBus } from '@ps/utils/event-bus'
import i18n from '@ps/lang'
const erase = {
  namespaced: true,

  state: {
    handImageDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '320px',
      top: '88px',
      right: 'calc(648px - 100vw)',
    },
    areaDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '312px',
      top: '88px',
      right: 'calc(640px - 100vw)',
    },
  },

  mutations: {
    openHandImageDialog(state) {
      state.handImageDialog.visible = true
    },
    closeHandImageDialog(state) {
      state.handImageDialog.visible = false
    },
    openAreaDialog(state) {
      state.areaDialog.visible = true
    },
    closeAreaDialog(state) {
      state.areaDialog.visible = false
    },
  },

  actions: {
    async addCustomJudgeAreas({ rootState }) {
      const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
      const customJudgeAreaGroup = getCustomJudgeAreaGroup(currentSceneNode)
      const customJudgeAreas = gameIframe.qcGame.add.node(customJudgeAreaGroup)
      customJudgeAreas.name =
        i18n.t('workbench.erase.event.area.title') +
        customJudgeAreaGroup.children.length
      const editorData = editorScript.getScript(customJudgeAreas)
      editorData.$data.nodeType = nodeTypes.customJudgeAreas
      editorData.$data.createFromPSScripts = [scripts.eraseLayer.name]
      const areaComponent = customJudgeAreas.addScript(scripts.eraseLayer.name)
      areaComponent.erasrLayerType = EraseType.CUSTOM_JUDGE_AREA
      areaComponent.canErase = true
      areaComponent.isEnableEraseable = true
      customJudgeAreas.visible = false
      return customJudgeAreas.uuid
    },
    addCustomJudgeArea({ state, rootState }, { areasNode }) {
      const customJudgeArea = gameIframe.qcGame.add.image(areasNode)
      customJudgeArea.name = 'rect'
      const res = gameIframe.qcGame.assets.find('__builtin_resource__')
      const emptyTexture = res.getTexture('empty.png')
      resetNodeDefaultLayout(customJudgeArea)
      customJudgeArea.texture = emptyTexture
      customJudgeArea.width = 200
      customJudgeArea.height = 200
      customJudgeArea.addScript(scripts.eraseArea.name)
      store.dispatch('workspace/game/updateActiveNode', {
        node: customJudgeArea,
        record: false,
      })
      store.dispatch('workspace/stage/addVirtualNode', customJudgeArea)
      EventBus.$emit(Event.ADD_GAME_OBJECT, customJudgeArea.uuid)
    },
    async copyCustomJudgeAreas({ rootState }, { areasNode }) {
      const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
      const customJudgeAreaGroup = getCustomJudgeAreaGroup(currentSceneNode)
      const nodes = cloneNode({
        originalNodes: [areasNode],
        parent: customJudgeAreaGroup,
        index: customJudgeAreaGroup.children.length,
      })
      nodes.forEach((node) => {
        node.visible = false
      })
    },
    deleteCustomJudgeAreas({ rootState }, { areasNode }) {
      const eraseComponent = areasNode.parent.parent.getScript(
        scripts.erase.name,
      )
      areasNode.parent.removeChild(areasNode)
      eraseComponent.customEvents.forEach((event) => {
        const index = event.area.indexOf(areasNode.uuid)
        if (index > -1) {
          event.area.splice(index, 1)
        }
      })
    },
    switchVisibleArea({ rootState }, { areasNode }) {
      areasNode.visible = !areasNode.visible
      if (areasNode.visible) {
        areasNode.parent.visible = true
      }
    },
    hideVisibleArea({ rootState }) {
      const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
      const customJudgeAreaGroup = getCustomJudgeAreaGroup(currentSceneNode)
      customJudgeAreaGroup.children.forEach((child) => {
        child.visible = false
      })
      customJudgeAreaGroup.visible = false
    },
  },
}

export default erase
